import { createSlice } from "@reduxjs/toolkit";

const medicinaState = {
  datamedicadisp: []
}

export const medicinadispSlice = createSlice({
  name: "medicinadisp",
  initialState: medicinaState,
  reducers: {
    StoreMedDispData: (state, actions) => {
      state.datamedicadisp = actions.payload;
    },
    ResetMedDispData: () => medicinaState,
  }
});

export const { StoreMedDispData, ResetMedDispData } = medicinadispSlice.actions;

export default medicinadispSlice.reducer;
